var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPersonPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "person_pin_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#person_pin_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#009EE7",
  d: "M20 37.624c-.222 0-.43-.035-.625-.105a1.463 1.463 0 0 1-.542-.354L15 33.332H8.333a3.21 3.21 0 0 1-2.354-.98A3.21 3.21 0 0 1 5 30V6.665c0-.916.326-1.701.98-2.354a3.21 3.21 0 0 1 2.353-.979h23.334a3.21 3.21 0 0 1 2.354.98A3.21 3.21 0 0 1 35 6.664V30a3.21 3.21 0 0 1-.98 2.354 3.21 3.21 0 0 1-2.353.979H25l-3.833 3.833a1.463 1.463 0 0 1-.542.355c-.194.069-.403.104-.625.104Zm0-17.625c1.611 0 2.986-.57 4.125-1.709 1.139-1.139 1.708-2.513 1.708-4.125 0-1.61-.57-2.986-1.708-4.125C22.986 8.901 21.611 8.332 20 8.332c-1.611 0-2.986.57-4.125 1.708-1.139 1.14-1.708 2.514-1.708 4.125 0 1.612.57 2.986 1.708 4.125C17.014 19.43 18.389 20 20 20Zm0 13.666L23.667 30h8v-1.917a16.8 16.8 0 0 0-5.23-3.48c-1.986-.846-4.131-1.27-6.437-1.27s-4.451.424-6.438 1.27a16.8 16.8 0 0 0-5.229 3.48v1.917h8L20 33.665Z"
}))));
export default SvgPersonPin;